import theme from "components/themes";

export const heatmapGradientColorsDefinition = {
  0: theme.colors.notificationRed,
  25: theme.colors.yellow,
  50: theme.colors.aquaMarine,
  75: theme.colors.infoBlue,
  100: theme.colors.purple,
};
